import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Stack } from "react-bootstrap";
import { InputText } from "primereact/inputtext";
import Button from "react-bootstrap/Button";
import "bootstrap/dist/css/bootstrap.min.css";
import "primeicons/primeicons.css";
import "./login.css";
import Stox from "../../pics/stoxkart_old_logo.png";
import axios from "axios";
import SideImg from '../../assets/side_img.svg'
import logo from '../../assets/stox.png'
import { useContext } from "react";
import { Context } from "../../Context/GlobalContext";
import Demo from "../geoTagging/Demo";


const LoginMain = ({ change, setChange }) => {
  // const { mobiEmail, setMobiEmail} = useContext(Context)
  const [error, setError] = useState(false);
  const [wait, setWait] = useState("");
  const URL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();

  


  const inputHandler = (event) => {
    if (error) {
      setError("");
    }
    setChange(event.target.value);
  };

  
  
  const sendOtp = async (event) => {
    try {
      setWait("Please Wait....");
      // event.currentTarget.disabled = true;
      const response = await axios.post(`${URL}/Login/sendOTP`, { userCode: change });
      // console.log(response);
// setMobiEmail(response?.data?.data?.messageToPrint)
sessionStorage.setItem("mobiEmail", response?.data?.data?.messageToPrint )
      localStorage.setItem("userCode", change);
      navigate("/verify");
    } catch (error) {
      // console.log(error);
      setError(error?.response?.data?.result?.flagMsg);
      setWait("");
    }
  };

  useEffect(() => {
    const keyDownHandler = event => {
      if (event.key === 'Enter') {
        sendOtp();
      }
    };
    document.addEventListener('keydown', keyDownHandler);
    return () => {
      document.removeEventListener('keydown', keyDownHandler);
    };
  }, [change]);
 
  return (
    <>
      <Stack direction="horizontal">
      <div className="left_panel1" style={{background: '#DCEBFB', height: '100vh', padding: '90px 65px 0px 0px'}}>
          <img src={logo} alt="logo"  width='100px' style={{    position: 'absolute', top: 10, left: 10}}/>
          <img
            src={SideImg}
            alt="left_pan_img"
            style={{ width: "40vw", height: "60vh" }}
          />
          <h3 style={{textAlign: 'center', marginTop: 20}}>Re-KYC with Stoxkart</h3>
          <p style={{textAlign: 'center'}}>Verify yourself with Re-KYC and re-connect with Stoxkart</p>
        </div>
        
        <div className="right_panel">
          <div className="img_logo">
            <img
              src={Stox}
              alt="/"
              style={{ width: 330, margin: "20px 20px 20px auto" }}
            />
          </div>
          <h2 style={{margin: 0}}>Welcome back to Stoxkart!</h2>
          <p style={{ fontSize: 12, marginBottom: "12%" }}>
          Resume your trading with us in few simple steps!
          </p>
          <h4 style={{ fontSize: 22 }}>Client ID</h4>
          <span className="p-input-icon-right" style={{ width: "100%" }}>
            {error ? (
              <i className="pi pi-info-circle" style={{ color: "red" }} />
            ) : null}
            
            <InputText
              type="text"
              name="userCode"
              className="p-inputtext-sm h-5"
              placeholder="Please Enter Your Client ID"
              onChange={inputHandler}
              maxlength="7"
              keyfilter="alphanum"
              value={change.toUpperCase()}
              autoFocus={true}
            />
          </span>
          <p style={{ color: "red", fontSize: 12, marginTop: 15 }}>
            {error ? error : null}
          </p>
          <div className="d-grid gap-2">
            <Button
              disabled={change.length <= 5}
              style={{
                backgroundColor: "#05BB75",
                border: "none",
                marginTop: "20%",
              }}
              size="md"
              onClick={sendOtp}
            >
              {wait ? wait : "Send OTP"}
            </Button>
            
          </div>
          
        </div>
        
      </Stack>
    </>
  );
};

export default LoginMain;
